import React, { useContext } from "react";
import { LangCtx } from "../../../../lib/context";
import '../../../../lib/ui/imageicon/Styles.css';
import "../../../../layouts/Layouts.css";
import "../../../../ui-styles/list/inlineFiltersList.css";
import "../../../../ui-styles/picker/picker.css";
import AddrDropDown from "../../../../lib/ui/dropdown/addressDropDown";
import InputField from '../../../../lib/ui/inputs/Input';
import countriesList from "../../../../config/countries.json";
import DateFnsUtils from '@date-io/date-fns';
import {
    KeyboardDatePicker,
    MuiPickersUtilsProvider,
} from '@material-ui/pickers';


const AddLicense = (props) => {
    const { l } = useContext(LangCtx);
  //  const { payload } = useContext(PayLoadCtx);

  //  const licenseList = [{ value: "", label: l.med_lic }, { value: "Child Specialist", label: "Child Specialist" }, { value: "Gynecologist", label: "Gynecologist" }, { value: "Heart Specialist", label: "Heart Specialist" },]
    
    const handleRemove = () => {
        props.removeLicense(props.index);
    }
    if (countriesList && countriesList[0] && countriesList[0].value !== "") {
        countriesList.unshift({
            value: "",
            label: l.select_country
        });
    }
    
    return (
        <div className="inputRowFeild" >
            <div className="medicalHdrRow">
                <div className="medHdrTitle">
                    <span>{l.med_prof} {props.index + 1}</span>
                </div>
                {props.index > 0 ?
                    <div className="medHdrActions">
                        <div className="removeField close" onClick={() => { handleRemove() }} key={props.index}></div>
                    </div>
                    : <div></div>
                }
            </div>
            <div className="medicalFields">
                {/* <small className="inpLabel">{l.med_lic}<span className="redTxt">*</span>:</small>
                <AddrDropDown
                    placeholder={l.med_lic}
                    items={countriesList}
                    name="license"
                    value={props.data.license}
                    onChange={(e) => props.handleChange('license',e.target.value, props.index)}
                /> */}
                <small className="inpLabel">{l.med_lic}<span className="redTxt">*</span>:</small>
                <InputField
                    placeholder={l.med_lic}
                    type="text"
                    name="license"
                    value={props.data.license}
                    maxLength="100"
                    onChange={(e) => props.handleChange('license',e.target.value, props.index)}
                />
                <small className="inpLabel">{l.lic_no}<span className="redTxt">*</span>:</small>
                <InputField
                    placeholder={l.lic_no}
                    type="text"
                    name="licenseNo"
                    value={props.data.licenseNo}
                    maxLength="15"
                    onChange={(e) => props.handleChange('licenseNo',e.target.value, props.index)}
                />
                <small className="inpLabel">{l.lic_exp_date}<span className="redTxt">*</span>:</small>
                <div className="inputBox alignCenter">
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDatePicker fullWidth
                            className="pickerInput"
                            name="expirationDate"
                            inputVariant="outlined"
                            value={new Date(props.data.expirationDate)}
                            onChange={(date) => {date && props.handleChange('expirationDate', date.valueOf(), props.index)}}
                            animateYearScrolling
                            placeholdertext={l.dob}
                            format="dd/MM/yyyy"
                            minDate={new Date()}
                        />
                        {/*<div className="inputIconBox"><img src="/images/icons/date.png" className="invertGray" alt="date"/></div>*/}
                    </MuiPickersUtilsProvider>
                </div>
                <small className="inpLabel">{l.select_country}<span className="redTxt">*</span>:</small>
                <AddrDropDown
                    // placeholder={l.select_country}
                    items={countriesList}
                    value={props.data.country}
                    onChange={(e) => props.handleChange('country',e.target.value, props.index)}
                    // onChange={(e) => props.setCountry(e.target.value)}
                />
            </div>
        </div>
    )
}

export default AddLicense;